enum SVG_ENUM {
  LOGO = "logo",
  EYE = "eye",
  CROSSED_EYE = "crossed-eye",
  CLOSE_CIRCLE = "close-circle",
  EP_SUCCESS = "ep-success",
  EP_FAIL = "ep-fail",
  FILTER = "filter",
  PAUSE_CIRCLE = "pause-circle",
  LOGO_WITHOUT_TEXT = "logo-without-text",
  PLAY_CIRCLE = "play-circle",
  BACK_CHEVRON = "back-chevron",
}

export default SVG_ENUM;
